export enum SupportRoutes {
  ContactUs = '/support/contact-us',
}
